import { useEffect, useState } from "react";
import { doc, updateDoc } from "firebase/firestore";
import Swal from "sweetalert2";
import { db } from "../../firebase";
import { THEME_COLOR } from "../../config/club";

export default function EditMatchModal({
    match,
    players,          // 👈 PASS ALL PLAYERS HERE
    onClose,
    clubId,
    sessionId,
}) {
    const [score, setScore] = useState(match.score || "");
    const [court, setCourt] = useState(match.court || "");
    const [scoreA, setScoreA] = useState(() => {
        const [a] = (match.score || "").split("-");
        return a || "";
    });

    const [scoreB, setScoreB] = useState(() => {
        const [, b] = (match.score || "").split("-");
        return b || "";
    });
    const [selectedPlayers, setSelectedPlayers] = useState(
        match.match || match.players || []
    );
    //console.log(selectedPlayers)
    // Update one player slot
    const updatePlayer = (index, playerId) => {
        if (!playerId) return;

        const player = players.find(p => p.id === playerId);
        if (!player) return;

        setSelectedPlayers(prev => {
            const updated = [...prev];

            updated[index] = {
                id: player.id,
                name: player.name || player.username || "Unknown",
                level: Number(player.level) || 0,
                joinedAt: player.joinedAt ?? serverTimestamp(),
                waitingSince: player.waitingSince ?? Date.now(),
                photoURL: player.photoURL ?? null,
                username: player.username ?? null,
            };

            return updated;
        });
    };

    const swapRow = (row) => {
        setSelectedPlayers(prev => {
            const updated = [...prev];
            const a = row;
            const b = row + 2;

            [updated[a], updated[b]] = [updated[b], updated[a]];
            return updated;
        });
    };
    const swapColumn = (team) => {
        setSelectedPlayers(prev => {
            const updated = [...prev];

            if (team === "A") {
                [updated[0], updated[1]] = [updated[1], updated[0]];
            } else {
                [updated[2], updated[3]] = [updated[3], updated[2]];
            }

            return updated;
        });
    };

    const save = async () => {
        // Validation
        const ids = selectedPlayers.map(p => p?.id);
        if (new Set(ids).size !== 4) {
            Swal.fire("Invalid", "Players must be unique", "warning");
            return;
        }
        // 🔒 Validation: score must be complete
        if (scoreA === "" || scoreB === "") {
            Swal.fire("Invalid", "Enter both scores", "warning");
            return;
        }

        const finalScore = `${Number(scoreA)}-${Number(scoreB)}`;
        await updateDoc(
            doc(db, "clubs", clubId, "sessions", sessionId, "matches", match.id),
            {
                score: finalScore,
                court: Number(court),
                players: selectedPlayers,
                updatedAt: new Date(),
            }
        );

        Swal.fire({
            icon: "success",
            title: "Match updated",
            timer: 1200,
            showConfirmButton: false,
        });

        onClose();
    };

    return (
        <div className="modal fade show d-block" style={{ background: "rgba(0,0,0,0.3)" }}>
            <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content rounded-4">
                    <div className="modal-header">
                        <h5 className="fw-bold">Edit Match</h5>
                        <button className="btn-close" onClick={onClose} />
                    </div>

                    <div className="modal-body">
                        <div className="row g-2">
                            
                            {/* COURT */}
                            <div className="col-12">
                                <label className="form-label fw-bold">Court</label>
                                <input
                                    type="number"
                                    className="form-control mb-4"
                                    value={court}
                                    onChange={e => setCourt(e.target.value)}
                                />
                            </div>
                            {/* SCORE */}
                            <div className="col-12">
                                <label className="form-label fw-bold">Score</label>

                                <div className="d-flex align-items-center gap-2">
                                    <input
                                        type="number"
                                        min="0"
                                        className="form-control text-center fw-black"
                                        placeholder="Team A"
                                        value={scoreA}
                                        onChange={(e) => setScoreA(e.target.value)}
                                    />

                                    <span className="fw-black text-muted">–</span>

                                    <input
                                        type="number"
                                        min="0"
                                        className="form-control text-center fw-black"
                                        placeholder="Team B"
                                        value={scoreB}
                                        onChange={(e) => setScoreB(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                        {/* PLAYERS */}
                        <div className="fw-bold mb-2">Players</div>
                        <div className="row g-2">
                            {[0, 1].map(row => (
                                <div key={row} className="col-12">

                                    {/* LABELS (only once) */}
                                    {row === 0 && (
                                        <div className="d-flex justify-content-between px-2 mb-1">
                                            <small className="fw-bold text-muted">TEAM A</small>
                                            <small className="fw-bold text-muted">TEAM B</small>
                                        </div>
                                    )}

                                    {/* ROW */}
                                    <div className="d-flex align-items-center gap-2">
                                        {/* TEAM A */}
                                        <select
                                            className="form-select rounded-pill shadow-sm"
                                            value={selectedPlayers[row]?.id || ""}
                                            onChange={(e) => updatePlayer(row, e.target.value)}
                                        >
                                            <option value="" disabled>Select Player</option>
                                            {players.map(player => (
                                                <option
                                                    key={player.id}
                                                    value={player.id}
                                                    disabled={selectedPlayers.some(
                                                        (sp, idx) => sp?.id === player.id && idx !== row
                                                    )}
                                                >
                                                    {player.name} (Lvl {player.level})
                                                </option>
                                            ))}
                                        </select>

                                        {/* SWAP ROW */}
                                        <button
                                            type="button"
                                            className="btn btn-light btn-sm rounded-circle flex-shrink-0"
                                            title="Swap sides"
                                            onClick={() => swapRow(row)}
                                        >
                                            🔁
                                        </button>

                                        {/* TEAM B */}
                                        <select
                                            className="form-select rounded-pill shadow-sm"
                                            value={selectedPlayers[row + 2]?.id || ""}
                                            onChange={(e) => updatePlayer(row + 2, e.target.value)}
                                        >
                                            <option value="" disabled>Select Player</option>
                                            {players.map(player => (
                                                <option
                                                    key={player.id}
                                                    value={player.id}
                                                    disabled={selectedPlayers.some(
                                                        (sp, idx) => sp?.id === player.id && idx !== row + 2
                                                    )}
                                                >
                                                    {player.name} (Lvl {player.level})
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    {/* COLUMN SWAP — UNDER TEAM A */}
                                    {row === 0 && (
                                        <div className="d-flex align-items-center gap-2">
                                            <div className="mt-1 ms-1">
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-secondary btn-sm rounded-pill"
                                                    onClick={() => swapColumn("A")}
                                                    style={{ fontSize: "0.65rem" }}
                                                >
                                                    🔁 Swap Team A
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button className="btn btn-light" onClick={onClose}>
                            Cancel
                        </button>
                        <button
                            className="btn text-white rounded-pill px-4"
                            style={{ backgroundColor: THEME_COLOR }}
                            onClick={save}
                        >
                            Save Changes
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
